import type { FaireProductEntity } from "../../entity_types/product";

export const p_sw694v4y4d: FaireProductEntity = {
  token: "p_sw694v4y4d",
  type: "product",
  name: "The Tallow Trio Gift Box",
  brandToken: "b_byf8uyy27h",
  brandName: "My Neighbor’s",
  imageUrl:
    "https://cdn.faire.com/fastly/fde91dbed2f0731f538b6d9962a2649aee64d188828599f7c6427cf12e774779.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/469f52f2c479d43a28ffa37d3c64542a5f8bca96cb3f61244ade66c47d8ffb6f.jpeg",
    "https://cdn.faire.com/fastly/73f253f0d77e9b9894fc6938a78f03efeb2de8ab4ba07b26ec396d85b2cc9a05.jpeg",
    "https://cdn.faire.com/fastly/828d76119ea46565b1cb402d65c8deece4e7237e729b0a316d7dd7f30126e69b.jpeg",
  ],
  priceDollars: 48.5,
  description:
    "The Tallow Trio Gift Box\n\nA stocking-sized introduction to our bestsellers — three 1oz balms crafted for face, body, and everything in between. Each set includes our Blue Tansy Face Balm for calm, radiant skin; Wild Bergamot Balm for daily body nourishment; and Rose & Sea Buckthorn Face Balm for deep renewal and glow.\n\nMade with grass-fed and finished tallow and the highest-quality botanicals, this trio is perfect for those looking to explore the full range of My Neighbor’s balms before committing to full sizes.\n\nGiftable. Travel-friendly. \n",
  tags: [],
  msrpDollars: 97,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:50.189Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
